







































































import { TbMember } from '@/http';
import { Component, Vue, Watch,Prop } from 'vue-property-decorator';
import addVipPanel from '../../vip/components/addVipPanel.vue';
@Component({
    components: {
        addVipPanel
    },
})
export default class memeberList extends Vue {
    public $refs: {
    };
    total = 0;

    searchValue:any={
        key:"",
        sortType:5,
        sortValue:2,
        skip:0,
        count:20
    };

    /**列表加载相关 */
    refreshing= false;
    loading = false;
    finished = false;
    list=[];
    currentPage=1

    addVipShow=false;

    @Watch('searchValue.key')
    keyChange(){
        this.serachList();
    }



    created() {
    }   
    
    mounted() {
       
    }

    /**下拉刷新 */
    async onRefresh(){
        // 清空列表数据
      this.finished = false;
       // 重新加载数据
      // 将 loading 设置为 true，表示处于加载状态
      this.loading = true;
      this.list = [];
      this.searchValue.skip=0;
      this.searchValue.count=20;
      this.total = 0;
      this.currentPage = 1;
      await this.loadMore();
    }
    /**触底加载 */
    async loadMore(){
            if (this.refreshing) {
                this.list = [];
                this.refreshing = false;
            }
            this.$nextTick(async()=>{
                let s = this.searchValue.count;
                let res = await TbMember.GetTbMemberList(Object.assign({},this.searchValue))
                this.list = this.searchValue.skip==0? res.items:this.list.concat(res.items);
                this.total  = res.totalCount;
                this.currentPage++;
                this.searchValue.skip = (this.currentPage - 1) * s;
                this.loading = false;
                if (this.list.length >= this.total) {
                this.finished = true;
                
                }
            })
    }
    async serachList(){
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=20;
        this.total = 0;
        this.currentPage = 1;
        
        let res = await TbMember.GetTbMemberList(Object.assign({},this.searchValue))
        this.list = res.items;
        this.total  = res.totalCount;

    }
    /**获取商品列表 */
    async getList(){
        // this.onRefresh();
        this.list = [];
        this.searchValue.skip=0;
        this.searchValue.count=20;
        this.total = 0;
        this.currentPage = 1;
        
        let res = await TbMember.GetTbMemberList(Object.assign({},this.searchValue))
        this.list = res.items;
        this.total  = res.totalCount;
    }
    inputSearch(){
        this.$nextTick(()=>{
            this.getList();
        })
    }
    /**重置 */
    resetSearch(){
        this.searchValue={
            key:"",
            sortType:5,
            sortValue:2,
            skip:0,
            count:20
        }
       
        this.getList();
    }

    addFun(){
        this.addVipShow = true;
    }

    closeAdd(){
        this.addVipShow = false;
    }
    confirmSaveAdd(){
        this.getList();
    }
    /**选择会员 */
    chooseMember(item){
        this.$emit('chooseMember',item);
    }

    

    
   
}



// WEBPACK FOOTER //
// ./node_modules/_vue-loader@14.2.4@vue-loader/lib/selector.js?type=script&index=0!./src/views/padViews/cashier/components/memeberList.vue